export function findProcessingCostRate(config, paymentMethod) {
  const processingCost = config.Behaviour?.ProcessingCost;
  if (!processingCost?.Enabled || !paymentMethod) return null;

  return (processingCost.Rates || []).find(rate => rate.PaymentMethod === paymentMethod) || null;
}

export function calculateProcessingCost(rate, amount) {
  const percentageAmount = Math.round(Number((amount * Number(rate.Percentage || 0) / 100).toFixed(6)));

  return Number(rate.FixedAmount || 0) + percentageAmount;
}

export function resolveProcessingCostAmount(config, formData) {
  if (!formData.processingCostAccepted) return null;

  const rate = findProcessingCostRate(config, formData.paymentMethod);

  return rate ? calculateProcessingCost(rate, baseAmount(formData)) : null;
}

export function resolveChargedAmount(config, formData) {
  return baseAmount(formData) + (resolveProcessingCostAmount(config, formData) || 0);
}

function baseAmount(formData) {
  return Math.round(Number(formData.amount || 0));
}
